<template>
    <footer class="container_footer">
        <article class="container_footer__article">
            <aside class="container_footer__article__aside_left">
                <div class="container_footer__article__aside_left__div">
                    <button class="container_footer__article__aside_left__div__button">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-plus-circle-fill container_footer__article__aside_left__div__button__svg" viewBox="0 0 16 16">
                            <path
                                d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                        </svg>
                    </button>
                </div>

            </aside>
            <aside class="container_footer__article__aside_middle">
                <div class="container_footer__article__aside_middle__div">
                    <img src="@/assets/Grand-Logo.png" alt="logo officiel"
                        class="container_footer__article__aside_middle__div__img">
                </div>
            </aside>
            <aside class="container_footer__article__aside_right">
                <div class="container_footer__article__aside_right__div">
                    <p class="container_footer__article__aside_right__div__p">
                        ©
                    </p>
                </div>
            </aside>
        </article>
    </footer>
</template>

<script >
export default {
    name: 'FooterMobile',
}

// function w3_open() {
//   document.getElementById("main").style.marginLeft = "25%";
//   document.getElementById("mySidebar").style.width = "25%";
//   document.getElementById("mySidebar").style.display = "block";
//   document.getElementById("openNav").style.display = 'none';
// }

// function w3_close() {
//   document.getElementById("main").style.marginLeft = "0%";
//   document.getElementById("mySidebar").style.display = "none";
// .display = "inline-block";
// }
</script>

<style  lang=scss scoped>
@import "@/style/color.scss";
@import "@/style/effets.scss";

.container_footer {
    height: 4rem;
    overflow: hidden;
    width: 100vw;

    &__article {
        margin: auto;
        width: 96vw;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        &__aside_left {
            width: 4rem;
            height: 4rem;


            &__div {
                width: 2rem;
                height: 2rem;
                margin: auto;
                margin-top: 1rem;

                &__button {
                    width: 2rem;
                    height: 2rem;
                    background-color: white;
                    border-radius: 2rem;
                    border: none;

                    &__svg {
                        color: white;
                        width: 2rem;
                        height: 2rem;
                        font-size: 1rem;
                        position: relative;
                        bottom: 0.1rem;
                        left: 0.02rem;
                    }
                }
            }
        }

        &__aside_middle {
            width: 50vw;
            height: 4rem;
            //background-color: red;
            overflow: hidden;

            &__div {
                margin-left: auto;
                margin-right: auto;
                margin-top: 0.5rem;
                width: 10rem;
                height: 3rem;
                //background-color: aqua;

                &__img {
                    position: relative;
                    //top: 0.5rem;
                    left: 2rem;
                    width: 6rem;
                }
            }
        }

        &__aside_right {
            width: 4rem;
            height: 4rem;

            &__div {
                width: 2rem;
                height: 2rem;
                margin: auto;
                margin-top: 1rem;
                text-align: center;

                &__p {
                    font-size: 3rem;
                    width: 2rem;
                    height: 2rem;
                    position: relative;
                    bottom: 1rem;
                    font-weight: bold;
                }
            }
        }
    }
}
</style>